<template>
  <div style="height: 100%">
    <el-table ref="table" :data="tableData" height="100%" max-height="100%" style="width: 100%" size="mini" :show-summary="true" :summary-method="getSummaries" :row-class-name="tableRowClassName" @sort-change="sortChange" @row-click="tableClick">
      <el-table-column type="index" align="center" width="40"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <el-table :data="row.children" height="100%" max-height="100%" stripe style="width: 100%" @row-dblclick="tableDBClick">
            <el-table-column width="40"></el-table-column>
            <el-table-column type="index" align="center" width="40"></el-table-column>
            <el-table-column prop="billNo" width="250" label="单号">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="billStatusItem[row.billStatus]">{{row.billStatusFormat}}</el-tag>
                <span style="margin-left: 6px">{{ row.billNo }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="entryDateTime" width="160" label="时间"> </el-table-column>
            <el-table-column prop="itemName" width="180" label="商品"> </el-table-column>
            <el-table-column prop="billType" width="80" label="类型">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="billTypeItem[row.billType]">{{row.billTypeFormat}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="customerName" width="110" label="客户"> </el-table-column>
            <el-table-column prop="billQtyFormat" width="116" label="数量"> </el-table-column>
            <el-table-column prop="billTotalAmt" width="110" label="金额"> </el-table-column>
            <el-table-column prop="desQtyFormat" width="116" label="配送数量"> </el-table-column>
            <el-table-column prop="remark" label="备注/整单备注"> </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="itemName" width="180" label="商品">
        <template slot-scope="{ row }">
          <div class="itemName">{{ row.itemName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="itemSpec" width="140" label="规格"> </el-table-column>
      <el-table-column prop="invBarCode" width="130" label="条码"> </el-table-column>
      <el-table-column prop="billNum" width="98" label="单据数" sortable="custom"> </el-table-column>
      <el-table-column prop="customerNum" width="98" label="客户数" sortable="custom"> </el-table-column>
      <el-table-column prop="salOrderTotalQty" width="138" label="销售下单数量" sortable="custom"> </el-table-column>
      <el-table-column prop="salOrderTotalAmt" width="138" label="销售下单金额" sortable="custom"> </el-table-column>
      <el-table-column prop="saleOrderConsignQty" width="138" label="销售配送数量" sortable="custom"> </el-table-column>
      <el-table-column prop="salBackOrderTotalQty" width="138" label="还货下单数量" sortable="custom"> </el-table-column>
      <el-table-column prop="saleBackOrderConsignQty" width="138" label="还货配送数量" sortable="custom"> </el-table-column>
      <el-table-column prop="salReturnOrderTotalQty" width="138" label="退货下单数量" sortable="custom"> </el-table-column>
      <el-table-column prop="salReturnOrderTotalAmt" width="138" label="退货下单金额" sortable="custom"> </el-table-column>
      <el-table-column> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array,
    tableSum: Object
  },
  data() {
    return {
      billStatusItem: {
        A: 'warning',
        C: 'success',
        D: 'danger',
        E: 'info',
      },
      billTypeItem: {
        XSD: '',
        HHD: 'success',
        XST: 'danger'
      }
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
      return 'height-row'
    },
    async tableClick(row) {
      if (row.isHaveDetail != 'Y') return false
      let expandEl = this.$refs.table.$el.querySelectorAll('.el-table__expand-icon')[row.index]
      this.activeExpandEl = expandEl
      let isExpand = expandEl.classList.contains('el-table__expand-icon--expanded')
      if (isExpand) {
        this.$refs.table.toggleRowExpansion(row)
      } else {
        let iconEl = expandEl.querySelector('.el-icon')
        iconEl.classList.remove('el-icon-arrow-right')
        iconEl.classList.add('el-icon-loading')
        this.$emit('expand-detail', row)
      }
    },
    toggleRowExpansion(row) {
      let iconEl = this.$refs.table.$el.querySelectorAll('.el-table__expand-icon .el-icon')[row.index]
      iconEl.classList.remove('el-icon-loading')
      iconEl.classList.add('el-icon-arrow-right')
      this.$refs.table.toggleRowExpansion(row)
    },
    tableDBClick(row) {
      this.$emit('draw-detail', row)
    },
    sortChange({ prop, order }) {
      this.$emit('sort-change', { prop, order })
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      for (let key in this.tableSum) {
        columns.forEach((column, index) => {
          if (index == 2) {
            sums[index] = "合计";
            return;
          }
          if (column.property == key) {
            sums[index] = this.tableSum[key];
            return;
          }
        });
      }
      this.$nextTick(() => {
        this.$refs["table"].doLayout();
      });
      return sums;
    }
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .el-table {
    th, td {
      // padding: 0;
      .cell {
        font-size: 14px;
      }
      .itemName {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .height-row {
      height: 59px;
    }
    .el-table__expand-column {
      position: relative;
      .cell::before {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        content: '';
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

</style>
